"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_dashboard_calendar_controller_1 = __importDefault(require("./admin-dashboard-calendar.controller"));
var calendar_html_1 = __importDefault(require("./calendar.html"));
function prepareCalendar(CalendarModel, DrivesFilterService) {
    return CalendarModel.getFilterOptions().then(function (response) {
        DrivesFilterService.setFilterOptions(response.options);
        return response.options;
    });
}
prepareCalendar.$inject = ["CalendarModel", "DrivesFilterService"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.calendar", {
        url: "/calendar",
        controller: admin_dashboard_calendar_controller_1.default,
        controllerAs: "vm",
        template: calendar_html_1.default,
        resolve: {
            filterOptions: prepareCalendar,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.calendar", [])
    .config(config)
    .controller("AdminCalendarController", admin_dashboard_calendar_controller_1.default);
